export default __webpack_public_path__ + "static/media/img_app_icon.0a94c7d8.png";